import { OPEN_HAMBURGER_NAV, CLOSE_HAMBURGER_NAV } from '../../../ActionsConst';

const initialState = false;
const hamburgerNav = (state = initialState, action) => {
  /* Keep the reducer clean - do not mutate the original state. */
  // let nextState = Object.assign({}, state);

  switch (action.type) {
    case OPEN_HAMBURGER_NAV:
      return true;

    case CLOSE_HAMBURGER_NAV:
      return false;

    default: {
      /* Return original state if no actions were consumed. */
      return state;
    }
  }
};

export default hamburgerNav;
